import { useId } from 'react';

type EmployerTaskListTitleIconProps = {
  className?: string;
};

/** Tight crop around artwork so CSS bottom alignment matches visual bottom edge. */
const TITLE_ICON_VIEWBOX = '35 52 335 252';

/** Employer task list page title — clipboard checklist with wavy liquid background. */
export const EmployerTaskListTitleIcon = ({ className = '' }: EmployerTaskListTitleIconProps) => {
  const uid = useId().replace(/:/g, '');
  const shadowFilterId = `employerTaskListTitle-softShadow-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={TITLE_ICON_VIEWBOX}
      preserveAspectRatio="xMidYMax meet"
      className={className}
      aria-hidden
    >
      <defs>
        <filter id={shadowFilterId} x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="2" dy="5" stdDeviation="4" floodColor="#07224d" floodOpacity="0.15" />
        </filter>
      </defs>

      <path
        d="M 90,140 C 50,160 45,210 75,235 C 95,250 100,265 120,272 C 150,282 180,270 210,272 C 240,274 265,282 285,270 C 310,255 355,220 325,180 C 305,150 345,110 295,95 C 255,80 220,120 165,95 C 125,75 115,120 90,140 Z"
        fill="#29ebd0"
        opacity="0.85"
      />

      <path
        d="M 105,155 C 75,170 70,210 95,230 C 110,240 115,255 135,262 C 160,270 185,260 210,262 C 235,264 255,270 270,260 C 290,245 325,215 305,185 C 290,160 320,125 280,110 C 245,95 215,130 170,110 C 135,95 125,135 105,155 Z"
        fill="#00c9b7"
        opacity="0.4"
      />

      <path
        d="M75,170 Q80,170 80,165 Q80,170 85,170 Q80,170 80,175 Q80,170 75,170 Z"
        fill="#ffffff"
      />
      <path
        d="M330,135 Q335,135 335,130 Q335,135 340,135 Q335,135 335,140 Q335,135 330,135 Z"
        fill="#ffffff"
      />

      <circle cx="95" cy="250" r="5" fill="#00bfa5" opacity="0.6" />
      <circle cx="325" cy="210" r="7" fill="#7ed321" opacity="0.7" />

      <rect
        x="130"
        y="90"
        width="140"
        height="190"
        rx="16"
        fill="#0d47a1"
        filter={`url(#${shadowFilterId})`}
      />
      <rect x="140" y="110" width="120" height="160" rx="8" fill="#ffffff" />

      <path
        d="M170,110 L230,110 C236,110 240,105 240,100 L240,93 C240,88 236,83 230,83 L170,83 C164,83 160,88 160,93 L160,100 C160,105 164,110 170,110 Z"
        fill="#ba68c8"
      />
      <rect x="185" y="90" width="30" height="8" rx="3" fill="#9c27b0" />

      <path
        d="M152,140 L157,145 L167,133"
        fill="none"
        stroke="#7ed321"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="175" y="133" width="65" height="5" rx="2.5" fill="#b0bec5" />
      <rect x="175" y="142" width="45" height="4" rx="2" fill="#cfd8dc" />

      <path
        d="M152,175 L157,180 L167,168"
        fill="none"
        stroke="#7ed321"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="175" y="168" width="70" height="5" rx="2.5" fill="#b0bec5" />
      <rect x="175" y="177" width="35" height="4" rx="2" fill="#cfd8dc" />

      <rect x="150" y="200" width="16" height="16" rx="4" fill="#00e676" />
      <rect x="175" y="203" width="55" height="5" rx="2.5" fill="#b0bec5" />
      <rect x="175" y="212" width="50" height="4" rx="2" fill="#cfd8dc" />

      <rect x="150" y="235" width="16" height="16" rx="4" fill="#ff4081" />
      <rect x="175" y="238" width="60" height="5" rx="2.5" fill="#b0bec5" />
      <rect x="175" y="247" width="40" height="4" rx="2" fill="#cfd8dc" />
    </svg>
  );
};
